import React, { FC, ReactElement } from 'react'
import { Box, Grid, Typography, Link, List, ListItem, useTheme } from '@mui/material'
import { useLocation } from 'react-router-dom'
import { ROUTES } from '../routes/routes'
import { MeasureDataContext } from '../contexts/MeasureDataProvider'


export const Footer: FC = (): ReactElement => {
  const theme = useTheme()
  const location = useLocation()
  const { allMeasures } = React.useContext(MeasureDataContext)
  const { length } = allMeasures

  const isCurrentPage = (path: string): boolean => {
    return location.pathname === path
  }

  const isConverterPage = (): boolean => {
    return Object.values(allMeasures).some(measure =>
      location.pathname.includes(`/${measure.url}`)
    )
  }

  return (
    <Box
      sx={{
        width: '100%',
        height: 'auto',
        paddingTop: '2rem',
        paddingBottom: '2rem',
        borderTop: 1,
        borderColor: 'divider',
        backgroundColor: theme.palette.custom.backgroundWhisperPurple
      }}
    >
      <Grid container justifyContent="space-between" alignItems="center" sx={{ maxWidth: '1450px', margin: '0 auto', flexDirection: { xs: 'column-reverse', md: 'row' } }}>
        <Grid item xs={12} md="auto" sx={{ textAlign: { xs: 'center', md: 'left' }, marginTop: { xs: '20px', md: '0' }, marginLeft: { md: '24px' } }}>
          <Typography color={theme.palette.grey[500]} sx={{ fontSize: '0.9rem' }}>
            {`© ${new Date().getFullYear()} `}
            <Link paddingTop={1} paddingBottom={1} color="inherit" underline="hover" href="https://topconverters.com">
              TopConverters.com
            </Link>
            . All rights reserved.
          </Typography>
        </Grid>
        <Grid item xs={12} md="auto" sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-end' }, marginRight: { md: '24px' } }}>
          <List sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, padding: 0 }}>
            <ListItem sx={{
                display: 'inline-flex',
                justifyContent: { xs: 'center', md: 'flex-start' },
                marginBottom: { xs: '10px', md: '0' },
                marginRight: '10px',
                padding: 0
              }}
            >
              <Typography color={theme.palette.grey[500]} sx={{ fontSize: '0.9rem' }}>
                <Link
                  whiteSpace={'nowrap'}
                  padding={1}
                  color="inherit"
                  underline="hover"
                  href={ROUTES.MEASURE.create(length)}
                  aria-current={isConverterPage() ? 'section' : undefined} // fyi link complains because section seems to be invalid
                  role="link"
                >
                    Converters
                </Link>
              </Typography>
            </ListItem>

            <ListItem sx={{ display: { xs: 'none', md: 'flex' }, marginRight: '10px', padding: 0 }}>
              <Typography color={theme.palette.grey[500]} sx={{ fontSize: '0.9rem' }}>
                &#9679; {/* bullet point between the links */}
              </Typography>
            </ListItem>
            <ListItem sx={{
                display: 'inline-flex',
                justifyContent: { xs: 'center', md: 'flex-start' },
                marginBottom: { xs: '10px', md: '0' },
                padding: 0
              }}
            >
              <Typography color={theme.palette.grey[500]} sx={{ fontSize: '0.9rem' }}>
                <Link
                  whiteSpace={'nowrap'}
                  padding={1}
                  color="inherit"
                  underline="hover"
                  href={ROUTES.ABOUT_US}
                  aria-current={isCurrentPage(ROUTES.ABOUT_US) ? 'page' : undefined}
                  role="link"
                >
                  About us
                </Link>
              </Typography>
            </ListItem>

            <ListItem sx={{ display: { xs: 'none', md: 'flex' }, marginRight: '10px', padding: 0 }}>
              <Typography color={theme.palette.grey[500]} sx={{ fontSize: '0.9rem' }}>
                &#9679; {/* bullet point between the links */}
              </Typography>
            </ListItem>
            <ListItem sx={{
              display: 'inline-flex',
              justifyContent: { xs: 'center', md: 'flex-start' },
              marginBottom: { xs: '10px', md: '0' },
              padding: 0
            }}>
              <Typography color={theme.palette.grey[500]} sx={{ fontSize: '0.9rem' }}>
                <Link
                  whiteSpace={'nowrap'}
                  padding={1}
                  color="inherit"
                  underline="hover"
                  href={ROUTES.CONTACT_US}
                  aria-current={isCurrentPage(ROUTES.CONTACT_US) ? 'page' : undefined}
                  role="link"
                >
                  Contact us
                </Link>
              </Typography>
            </ListItem>
          </List>
        </Grid>
      </Grid>
    </Box>
  )
}

export default Footer
